import { PushMessageSelection } from "./pushMessageSelection";

export class FormValueSelection {
  confId: number;
  selection: PushMessageSelection;
}